import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { LightBoxContentWrapper } from './subcomponents/LightBoxContentWrapper/LightBoxContentWrapper';
import { MediaGalleryMobileAd } from './subcomponents/MediaGalleryMobileAd/MediaGalleryMobileAd';
import { MediaGalleryDesktopAd } from './subcomponents/MediaGalleryDesktopAd/MediaGalleryDesktopAd';
import { MediaGalleryCarousel } from '../MediaGalleryCarousel/MediaGalleryCarousel';
import { MediaGalleryTimelineWithData } from '../MediaGalleryTimeline/MediaGalleryTimelineWithData';
import { MediaGalleryActionBarWithData } from './MediaGalleryActionBarWithData';

const ContentWrapper = styled.div`
  /* 320px is our min supported mobile width and height considering portrait and landscape. Will force scrolling at lower */
  min-height: 320px;
  min-width: 320px;
  height: 100%;
`;

const ContentRow = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
`;

const MediaGalleryColumn = styled.div`
  margin: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* needed so takes remaining space available */
  flex: 1;
  /* needed so can shrink under 100% */
  min-width: 0;
`;

const MediaGalleryMainContentColumn = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const MediaGalleryCarouselWrapper = styled(LightBoxContentWrapper)`
  /* needed so takes remaining space when mobile ad is present */
  flex: 1;
`;

interface MediaGalleryLightBoxContentProps {
  opened: boolean;
  onClose: () => void;
}

export const MediaGalleryLightBoxContent: FunctionComponent<MediaGalleryLightBoxContentProps> = ({
  opened,
  onClose,
}) => {
  return (
    <ContentWrapper>
      <ContentRow>
        <MediaGalleryColumn>
          <MediaGalleryActionBarWithData onClose={onClose} opened={opened} />
          <MediaGalleryMainContentColumn>
            <MediaGalleryCarouselWrapper>
              <MediaGalleryCarousel Timeline={<MediaGalleryTimelineWithData />} />
            </MediaGalleryCarouselWrapper>
            <MediaGalleryMobileAd />
          </MediaGalleryMainContentColumn>
        </MediaGalleryColumn>
        <MediaGalleryDesktopAd />
      </ContentRow>
    </ContentWrapper>
  );
};
